module.exports = __webpack_public_path__ + "static/media/why-image.bc462285.webm";